<div class="svenn-loader">
  <img src="assets/sidebar/Svenn_App_icon.png" alt="Svenn" class="svenn-loader--logo" />
  <img src="assets/iconmoon-icons/Svenn_Logo_Dark_ico.svg" alt="Svenn" class="svenn-loader--text" />
</div>
